<template>
  <!--  create folder dialog   -->
  <qc-dialog class="tc-15-rich-dialog cos" :show="innerShow" type="custom" :title="$t('core.create_folder')"
    :default-cancel="false" :width="420" @close="closeDialog">
    <ul class="form-list">
      <li class="pure-text-row">
        <div class="form-label">
          <label>{{$t("core.folder_name")}}</label>
        </div>
        <div class="form-input">
          <div class="form-unit" :class="{'is-error':!validateStatus}">
            <input class="tc-15-input-text m" v-focus maxlength="100" v-model.trim="createName"
              @keyup="validateName" @input="validateName" @keypress.enter="createFolder()">
            <qc-bubble popupClass="dialog-bubble" class="ml-10" placement="bottomRight">
              <qc-icon type="plaint" style="cursor:pointer"></qc-icon>
              <template slot="popup">
                {{$t('cos.tips.folder_name[0]')}}<br>
                {{$t('cos.tips.folder_name[1]')}}<br>
                {{$t('cos.tips.folder_name[2]')}}<br>
                {{$t('cos.tips.folder_name[3]')}}
              </template>
            </qc-bubble>
            <p class="form-input-help">{{$t(`cos.validate.${validateCode}`)}}</p>
          </div>
        </div>
      </li>
    </ul>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="default" @click="createFolder()" :title="$t('core.ok')"
            :disabled="!validateStatus || !createName">{{$t('core.ok')}}</qc-button>
          <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}</qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
import { tips, getStringBytes } from 'tools/utils';
import { cos } from 'helper/cos/index';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    bucketInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      createName: '',
      validateStatus: true,
      validateCode: 'folder_name_length',
    };
  },
  computed: {
    innerShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      },
    },
  },
  watch: {
    show() {
      // 弹窗打开后初始化重命名的文件项
      if (this.show) {
        this.createName = '';
        this.validateStatus = true;
        this.validateCode = 'folder_name_length';
      }
    },
  },
  methods: {
    validateName() {
      let errCode = 'folder_name_length';
      const name = this.createName;
      this.validateStatus = true;

      if (name === '' || /^\s+$/.test(name)) {
        this.validateStatus = false;
        errCode = 'folder_name[0]';
      }

      if (name.length > 255) {
        this.validateStatus = false;
        errCode = 'folder_name[1]';
      }

      if (name[0] === '/') {
        this.validateStatus = false;
        errCode = 'folder_name[2]';
      }

      if (name.indexOf('//') !== -1) {
        this.validateStatus = false;
        errCode = 'folder_name[3]';
      }

      if (name.split('/').indexOf('..') !== -1) {
        this.validateStatus = false;
        errCode = 'folder_name[4]';
      }

      let folderPath = `${this.bucketInfo.prefix + name}`;

      // 即如果用户自己补了 / 的话，则不添加 /
      if (folderPath.slice(-1) !== '/') {
        folderPath += '/';
      }

      if (getStringBytes(folderPath) > 850) {
        this.validateStatus = false;
        errCode = 'folder_name[5]';
      }

      this.validateCode = errCode;
      return errCode;
    },
    createFolder(notips) {
      const { Bucket, Region, Prefix } = this.bucketInfo;
      const name = notips ? '' : this.createName;

      let key = `${Prefix + name}`;
      // 如果用户自己补了 / 的话，则不添加 /
      if (key.slice(-1) !== '/') {
        key += '/';
      }

      if (!this.validateStatus && !notips) {
        return;
      }

      cos.putObject(
        {
          Bucket,
          Region,
          Key: key,
          Body: '',
          ContentType: 'application/x-directory',
          SkipTask: true,
        },
        err => {
          if (err) {
            // const {error} = err;
            // if(error){

            // }
            tips.error(
              this.$t('core.fail', { msg: this.$t('core.create_folder') }),
            );
          } else if (!notips) {
            tips.success(
              this.$t('core.success', { msg: this.$t('core.create_folder') }),
            );
            const item = { Prefix: key };
            this.$emit('push-list', [item]); // 增加文件
          }
          this.closeDialog();
        },
      );
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$xs: 360px;
$sm: 600px;
::v-deep .tc-15-rich-dialog {
  @media screen and (max-width: $sm) {
    width: 100% !important;
  }
  .form-input {
    .form-unit {
      input {
        width: 250px;
        @media screen and (max-width: $sm) {
          width: 80%;
        }
      }
    }
  }
}
</style>
